import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import PlayerPage from './components/PlayerPage';
import NotFound from './components/NotFound';
import './App.css';
import Analytics from './components/Analytics';

const theme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

// Redirect component for root path
const RedirectToDemo: React.FC = () => {
  React.useEffect(() => {
    window.location.href = 'https://verfi.io/demo-proof';
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <p>Redirecting...</p>
      </div>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Analytics />
      <div className="app-container">
        <Routes>
          <Route path="/" element={<RedirectToDemo />} />
          <Route path="/:verfiID" element={<PlayerPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
